<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">TAT Mapping Info.</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="card-body" [formGroup]="detailsForm">
                    <div class="row mb-4">
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="product" class="form-label">Product</label>
                                <ng-select id="product" formControlName="ddlProduct" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="productOptions" bindLabel="name" [bindValue]="'id'" >
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.name }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="formVendor" class="form-label">Vendor</label>
                                <ng-select id="formVendor" formControlName="ddlVendor" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="vendorOptions" bindLabel="name" [bindValue]="'id'" >
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.name }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="card-header bg-transparent border-bottom text-uppercase">Origin</div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="pincode" class="form-label">Pincode</label>
                                <div class="input-group">
                                    <input formControlName="txtOriginPincode" type="text" class="form-control col form-control-sm" 
                                        placeholder="Type to search" [ngbTypeahead]="searchPincode" [resultTemplate]="pt"
                                        [inputFormatter]="pincodeFormatter" (selectItem)="bindOriginByPincode($event)"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || detailsForm.get('txtOriginPincode')?.touched) && detailsForm.get('txtOriginPincode').errors}"  />
                                    <div *ngIf="(isFormSubmitted || detailsForm.get('txtOriginPincode')?.touched) && detailsForm.get('txtOriginPincode').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="detailsForm.get('txtOriginPincode').errors.pattern">Min 6 and Max 10 characters allowed.</span>
                                    </div>
                                </div>
                                <ng-template #pt let-p="result" let-t="term">
                                    <ngb-highlight [result]="p.pincode" [term]="t"></ngb-highlight>
                                    <!-- <span> | {{r['code']}}</span> -->
                                </ng-template>
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="country" class="form-label">Country</label>
                                <ng-select id="country" formControlName="ddlOriginCountry" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="originCountryList" bindLabel="name" [bindValue]="'isocode'"
                                    (change)="onOriginCountryChange()"  />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="state" class="form-label">State</label>
                                <ng-select id="state" formControlName="ddlOriginState" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="originStateList" bindLabel="name" [bindValue]="'isocode'"
                                    (change)="onOriginStateChange()"  />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="city" class="form-label">City</label>
                                <ng-select id="city" formControlName="ddlOriginCity" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="originCityList" bindLabel="name" [bindValue]="'isocode'"  />
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="card-header bg-transparent border-bottom text-uppercase">Destination</div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="pincode" class="form-label">Pincode</label>
                                <div class="input-group">
                                    <input formControlName="txtDestinationPincode" type="text" class="form-control col form-control-sm"
                                        placeholder="Type to search" [ngbTypeahead]="searchPincode" [resultTemplate]="pt"
                                        [inputFormatter]="pincodeFormatter" (selectItem)="bindDestinationByPincode($event)"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || detailsForm.get('txtDestinationPincode')?.touched) && detailsForm.get('txtDestinationPincode').errors}"  />
                                    <div *ngIf="(isFormSubmitted || detailsForm.get('txtDestinationPincode')?.touched) && detailsForm.get('txtDestinationPincode').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="detailsForm.get('txtDestinationPincode').errors.pattern">Min 6 and Max 10 characters allowed.</span>
                                    </div>
                                </div>
                                <ng-template #pt let-p="result" let-t="term">
                                    <ngb-highlight [result]="p.pincode" [term]="t"></ngb-highlight>
                                    <!-- <span> | {{r['code']}}</span> -->
                                </ng-template>
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="country" class="form-label">Country</label>
                                <ng-select id="country" formControlName="ddlDestinationCountry" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationCountryList" bindLabel="name" [bindValue]="'isocode'"
                                    (change)="onDestinationCountryChange()"  />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="state" class="form-label">State</label>
                                <ng-select id="state" formControlName="ddlDestinationState" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationStateList" bindLabel="name" [bindValue]="'isocode'"
                                    (change)="onDestinationStateChange()"  />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="city" class="form-label">City</label>
                                <ng-select id="city" formControlName="ddlDestinationCity" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationCityList" bindLabel="name" [bindValue]="'isocode'"  />
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-md-2">
                            <label for="days" class="form-label">Days</label>
                            <input type="number" class="form-control form-control-sm" formControlName="txtDays" id="days"
                                [ngClass]="{'is-invalid': (isFormSubmitted || detailsForm.get('txtDays')?.touched) && detailsForm.get('txtDays').errors}" >
                            
                            <div *ngIf="(isFormSubmitted || detailsForm.get('txtDays')?.touched) && detailsForm.get('txtDays').errors" class="invalid-feedback">
                                <span *ngIf="detailsForm.get('txtDays').errors.required">Days are required</span>
                                <span *ngIf="detailsForm.get('txtDays').errors.max">Please enter a number max up to 10</span>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label for="hours" class="form-label">Hours</label>
                            <input type="number" class="form-control form-control-sm" formControlName="txtHours" id="hours"
                                [ngClass]="{'is-invalid': (isFormSubmitted || detailsForm.get('txtHours')?.touched) && detailsForm.get('txtHours').errors}" >
                            
                            <div *ngIf="(isFormSubmitted || detailsForm.get('txtHours')?.touched) && detailsForm.get('txtHours').errors" class="invalid-feedback">
                                <span *ngIf="detailsForm.get('txtHours').errors.required">Hours are required</span>
                                <span *ngIf="detailsForm.get('txtHours').errors.max">Please enter a number max up to 23</span>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label for="fixedtime" class="form-label">Fixed Time</label>
                            <input type="number" class="form-control form-control-sm" formControlName="txtFixedTime" id="fixedtime" >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button title="Update" type="button" class="btn btn-primary " data-dismiss="modal" 
        (click)="update()">Update</button>
    <button type="button" class="btn btn-secondary " data-dismiss="modal"
        (click)="activeModal.dismiss('Cross click')">Cancel</button>
</div>